export const ObbyFaqTypes = {
  QUICKSTART: "quickstart",
  PRICING: "pricing"
};
